/**
 * Picks the download name from an API response. Content-Filename is
 * URL-escaped by the API; Content-Disposition may use filename* (RFC 6266).
 */
export function fileNameFromHeaders(header: (name: string) => string | null, fallback: string): string {
  const explicit = header("Content-Filename")
  if (explicit) {
    return safeDecode(explicit)
  }
  const disposition = header("Content-Disposition") || ""
  const extended = /filename\*\s*=\s*[\w-]*'[^']*'([^;]+)/i.exec(disposition)
  if (extended) {
    return safeDecode(extended[1].trim())
  }
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(disposition)
  if (plain) {
    return plain[1].trim()
  }
  return fallback
}

/** The plan checker answers "<name>_filled<ext>"; used when headers are hidden. */
export function filledPlanName(uploaded: string): string {
  const dot = uploaded.lastIndexOf(".")
  return dot > 0 ? `${uploaded.slice(0, dot)}_filled${uploaded.slice(dot)}` : `${uploaded}_filled`
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

export const AUDIT_READY_MESSAGE = "lobbyze-audit-ready"
export const AUDIT_TOKEN_MESSAGE = "lobbyze-audit-token"

/** True when event is the API page announcing it can take the token. */
export function isTokenRequest(event: { source: unknown; origin: string; data: unknown }, page: unknown, apiOrigin: string): boolean {
  const data = event.data as { type?: unknown } | null
  return event.source === page && event.origin === apiOrigin && data?.type === AUDIT_READY_MESSAGE
}
